<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <div class="vehicle-view-toolbar">
            <v-spacer></v-spacer>
            <v-btn-toggle v-model="viewMode" mandatory dense>
              <v-btn small value="card">
                <v-icon small left>fa-th-large</v-icon>
                Card
              </v-btn>
              <v-btn small value="table">
                <v-icon small left>fa-list</v-icon>
                Bảng
              </v-btn>
            </v-btn-toggle>
          </div>
          <v-data-table
            v-if="viewMode === 'table'"
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID" v-bind:class="{ 'warning-line': (item.ReceivedNumberOfPack || 0) < (item.NumberOfPack || 0)}">
                <td>{{ item.VehicleCode }}</td>
                <td>{{ item.LicensePlate }}</td>
                <td>
                  <v-chip small :color="getStatusColor(item.Status)" text-color="white">
                    {{ getStatusName(item.Status) }}
                  </v-chip>
                </td>
                <td class="text-right">{{ item.NumberOfPack }}</td>
                <td class="text-right font-weight-bold text-success">{{ item.ReceivedNumberOfPack || 0 }}</td>
                <td class="text-right">{{ item.TotalWeight }} kg</td>
                <td class="text-right">{{ item.TotalVolume }} m³</td>
                <td>{{ item.LoadDate | display_date('DD-MM-YYYY HH:mm') }}</td>
                <td>{{ item.ImportDate | display_date('DD-MM-YYYY HH:mm') }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">fa-external-link-alt</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div v-else class="vehicle-card-wrapper">
            <div v-if="loading" class="px-4 pb-4">
              <v-progress-linear indeterminate color="primary"></v-progress-linear>
            </div>
            <div v-else-if="!items || items.length === 0" class="vehicle-card-empty">
              Không có xe hàng phù hợp bộ lọc hiện tại.
            </div>
            <div v-else class="vehicle-card-grid">
              <v-card
                v-for="item in items"
                :key="item.ID"
                class="vehicle-card"
                :style="{ borderTopColor: (item.ReceivedNumberOfPack || 0) < (item.NumberOfPack || 0) ? 'red' : getStepColor(item.Status) }"
              >
                <div class="vehicle-card__header">
                  <div>
                    <div class="vehicle-card__code">{{ item.VehicleCode || ('#' + item.ID) }}</div>
                    <div class="vehicle-card__plate">Biển số: {{ item.LicensePlate || 'Chưa cập nhật' }}</div>
                  </div>
                  <v-chip small :color="getStatusColor(item.Status)" :text-color="getStatusTextColor(item.Status)">
                    {{ getStatusName(item.Status) }}
                  </v-chip>
                </div>

                <div class="vehicle-card__stats">
                  <div class="vehicle-card__stat">
                    <span class="vehicle-card__stat-label">Số kiện</span>
                    <strong class="vehicle-card__stat-value">{{ item.NumberOfPack || 0 }}</strong>
                  </div>
                  <div class="vehicle-card__stat">
                    <span class="vehicle-card__stat-label font-weight-bold text-success">Đã nhận VN</span>
                    <strong class="vehicle-card__stat-value text-success font-weight-bold">{{ item.ReceivedNumberOfPack || 0 }}</strong>
                  </div>
                  <div class="vehicle-card__stat">
                    <span class="vehicle-card__stat-label">Tổng kg</span>
                    <strong class="vehicle-card__stat-value">{{ formatVehicleWeight(item.TotalWeight) }} kg</strong>
                  </div>
                  <div class="vehicle-card__stat">
                    <span class="vehicle-card__stat-label">Tổng CBM</span>
                    <strong class="vehicle-card__stat-value">{{ formatVehicleVolume(item.TotalVolume) }} m³</strong>
                  </div>
                </div>

                <div class="vehicle-card__footer">
                  Tạo: {{ item.CreatedBy || 'Hệ thống' }} · {{ item.CreatedDate | display_date('DD/MM') }}
                </div>

                <div class="vehicle-card__actions">
                  <v-btn outlined small color="primary" @click="gotoDetail(item.ID)">
                    <v-icon small left>fa-eye</v-icon>
                    Nhập kho xe
                  </v-btn>
                </div>
              </v-card>
            </div>

            <div class="vehicle-card-footer">
              <div class="vehicle-card-footer__meta">
                Hiển thị {{ paginationText }}
              </div>
              <div class="vehicle-card-footer__controls">
                <v-select
                  v-model="pagination.itemsPerPage"
                  :items="itemsPerPageOptions"
                  dense
                  outlined
                  hide-details
                  class="vehicle-card-footer__select"
                  label="Số dòng"
                ></v-select>
                <v-pagination
                  v-model="pagination.page"
                  :length="totalPages"
                  :total-visible="7"
                ></v-pagination>
              </div>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
  },
  data() {
    return {
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "storemanager_vn_list",
      filterConditions: [],
      quickFilterConditions: [],
      viewMode: "table",
      vehicleStatusEnum: configs.VEHICLE_STATUS_ENUM,
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    viewMode(value) {
      this.syncViewModeToQuery(value);
    },
    '$route.query.vehicleView'(value) {
      const normalizedViewMode = this.normalizeViewMode(value);
      if (normalizedViewMode !== this.viewMode) {
        this.viewMode = normalizedViewMode;
      }
    }
  },
  computed: {
    ...mapState({
      items: state => state.vehicle.all.data,
      total_rows: state => state.vehicle.all.total,
      loading: state => state.vehicle.loading,
    }),
    param() {
      let pr = {
        pagination: this.pagination,
        filter: _.cloneDeep(this.filterConditions),
        quickFilter: this.quickFilterConditions
      };
      // Lọc cứng trạng thái Nhập kho VN
      pr.filter.push({
        column: "Status",
        value: configs.VEHICLE_STATUS_ENUM.NHAP_KHO_VN,
        condition: "equal"
      });
      return pr;
    },
    itemsPerPageOptions() {
      return _.get(this.items_per_page, "items-per-page-options", [20, 30, 40, 50, 100]);
    },
    totalPages() {
      const itemsPerPage = Number(this.pagination.itemsPerPage) || 20;
      const total = Number(this.total_rows) || 0;
      return Math.max(1, Math.ceil(total / itemsPerPage));
    },
    paginationText() {
      const total = Number(this.total_rows) || 0;
      if (total === 0) {
        return "0 kết quả";
      }
      const itemsPerPage = Number(this.pagination.itemsPerPage) || 20;
      const page = Number(this.pagination.page) || 1;
      const start = (page - 1) * itemsPerPage + 1;
      const end = Math.min(total, start + (this.items ? this.items.length : 0) - 1);
      return `${start}-${end} / ${total}`;
    },
    headers() {
      let dataType = configs.DATA_TYPE;
      return [
        {
          text: "Mã xe",
          value: "VehicleCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Biển số xe",
          value: "LicensePlate",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.VEHICLE_STATUS,
          dataType: dataType["Enum"]
        },
        {
          text: "Số kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số kiện đã nhận",
          value: "ReceivedNumberOfPack",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng kg",
          value: "TotalWeight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng m³",
          value: "TotalVolume",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ngày xếp xe",
          value: "LoadDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ngày nhập VN",
          value: "ImportDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ];
    }
  },
  methods: {
    filter_data() {
      this.$store.dispatch("vehicle/getList", this.param);
    },
    getStatusColor(status) {
      const match = _.find(configs.VEHICLE_STATUS, { value: status });
      return match ? match.color : "grey";
    },
    getStatusName(status) {
      const match = _.find(configs.VEHICLE_STATUS, { value: status });
      return match ? match.name : "Không xác định";
    },
    getStatusTextColor(status) {
      const match = _.find(configs.VEHICLE_STATUS, { value: status });
      return match ? (match.textColor || "white") : "white";
    },
    getStepColor(stepValue) {
      const match = _.find(configs.VEHICLE_STATUS, { value: stepValue });
      const stepColors = {
        orange: "#fb8c00",
        blue: "#1e88e5",
        indigo: "#3949ab",
        "cyan darken-2": "#00acc1",
        "deep-purple": "#5e35b1",
        green: "#43a047"
      };
      return stepColors[match ? match.color : ""] || "#90a4ae";
    },
    formatVehicleWeight(value) {
      const numberValue = Number(value) || 0;
      return numberValue.toLocaleString("vi-VN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    formatVehicleVolume(value) {
      const numberValue = Number(value) || 0;
      return numberValue.toLocaleString("vi-VN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    normalizeViewMode(value) {
      return value === "card" ? "card" : "table";
    },
    syncViewModeToQuery(value) {
      const nextViewMode = this.normalizeViewMode(value);
      const currentViewMode = this.normalizeViewMode(this.$route.query.vehicleView);
      if (currentViewMode === nextViewMode) {
        return;
      }
      this.$router.replace({
        query: {
          ...this.$route.query,
          vehicleView: nextViewMode
        }
      });
    },
    gotoDetail(id) {
      this.$router.push({
        name: "StoreManagerVNDetail",
        params: {
          Pid: id,
          title: "Chi tiết nhập kho VN"
        }
      });
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    }
  },
  mounted() {
    this.viewMode = this.normalizeViewMode(this.$route.query.vehicleView);
    this.syncViewModeToQuery(this.viewMode);
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: true}); // Không cho phép tạo xe từ đây
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.filter_data();
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>

<style scoped>
.text-success {
  color: #4cae4c !important;
}
.vehicle-view-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 16px 12px;
}

.vehicle-card-wrapper {
  padding: 0 16px 16px;
}

.vehicle-card-empty {
  padding: 48px 16px;
  text-align: center;
  color: #607080;
}

.vehicle-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

.vehicle-card {
  border-top: 4px solid #90a4ae;
  border-radius: 14px;
  padding: 16px;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.vehicle-card:hover {
  box-shadow: 0 10px 24px rgba(27, 39, 51, 0.1);
  transform: translateY(-1px);
}

.vehicle-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.vehicle-card__code {
  font-size: 18px;
  font-weight: 700;
  color: #1b2733;
}

.vehicle-card__plate {
  margin-top: 4px;
  font-size: 13px;
  color: #6b7a8c;
}

.vehicle-card__stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 16px;
}

.vehicle-card__stat {
  border: 1px solid #e3e6eb;
  border-radius: 10px;
  padding: 10px 12px;
  background: #fafbfc;
}

.vehicle-card__stat-label {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  color: #708090;
}

.vehicle-card__stat-value {
  font-size: 16px;
  color: #1b2733;
}

.vehicle-card__footer {
  margin-top: 14px;
  font-size: 13px;
  color: #6b7a8c;
}

.vehicle-card__actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.vehicle-card__actions .v-btn {
  flex: 1;
}

.vehicle-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 18px;
}

.vehicle-card-footer__meta {
  color: #607080;
  font-size: 13px;
}

.vehicle-card-footer__controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.vehicle-card-footer__select {
  width: 120px;
}

@media (max-width: 959px) {
  .vehicle-card-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }

  .vehicle-card-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .vehicle-card-footer__controls {
    flex-direction: column;
    align-items: stretch;
  }

  .vehicle-card-footer__select {
    width: 100%;
  }
}
</style>
